import React, { useState, useContext } from 'react';
import { AuthContext } from '../context/AuthContext';
import api from '../services/api';
import config from '../config/config';
import './Settings.css';

const Settings = () => {
  const { user, logout } = useContext(AuthContext);
  const [serverUrl, setServerUrl] = useState(localStorage.getItem('serverUrl') || config.defaultServerUrl);
  const [currentPassword, setCurrentPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState({ type: '', text: '' });

  const handleSaveSettings = async (event) => {
    event.preventDefault();
    setLoading(true);
    setMessage({ type: '', text: '' });

    try {
      localStorage.setItem('serverUrl', serverUrl);
      api.setBaseUrl(serverUrl);

      setMessage({
        type: 'success',
        text: 'Settings saved successfully'
      });
    } catch (error) {
      console.error('Error saving settings:', error);
      setMessage({
        type: 'error',
        text: 'Failed to save settings. Please try again.'
      });
    } finally {
      setLoading(false);
    }
  };

  const handleChangePassword = async (event) => {
    event.preventDefault();
    setLoading(true);
    setMessage({ type: '', text: '' });

    if (newPassword !== confirmPassword) {
      setMessage({
        type: 'error',
        text: 'New passwords do not match'
      });
      setLoading(false);
      return;
    }

    try {
      await api.post('/api/auth/change-password', {
        currentPassword,
        newPassword
      });

      setCurrentPassword('');
      setNewPassword('');
      setConfirmPassword('');

      setMessage({
        type: 'success',
        text: 'Password changed successfully'
      });
    } catch (error) {
      console.error('Error changing password:', error);
      setMessage({
        type: 'error',
        text: error.response?.data?.message || 'Failed to change password. Please try again.'
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="settings-page page-shell">
      <div className="container">

        {message.text && (
          <div className={`alert ${message.type === 'error' ? 'alert-danger' : 'alert-success'}`}>
            {message.text}
          </div>
        )}

        <div className="settings-grid">
          <section className="settings-card surface-card">
            <div className="settings-card-heading">
              <h2>General settings</h2>
              <p>Manage where this client connects and how frequently it syncs.</p>
            </div>

            <form onSubmit={handleSaveSettings}>
              <div className="form-group">
                <label htmlFor="server-url">Server URL</label>
                <input
                  type="url"
                  id="server-url"
                  className="form-control"
                  value={serverUrl}
                  onChange={(event) => setServerUrl(event.target.value)}
                  required
                />
                <small className="form-text">The URL of your FlashSync server.</small>
              </div>

              <button type="submit" className="btn btn-primary" disabled={loading}>
                {loading ? 'Saving...' : 'Save settings'}
              </button>
            </form>
          </section>

          <section className="settings-card surface-card">
            <div className="settings-card-heading">
              <h2>Change password</h2>
              <p>Rotate your account credentials without leaving the dashboard.</p>
            </div>

            <form onSubmit={handleChangePassword}>
              <div className="form-group">
                <label htmlFor="current-password">Current password</label>
                <input
                  type="password"
                  id="current-password"
                  className="form-control"
                  value={currentPassword}
                  onChange={(event) => setCurrentPassword(event.target.value)}
                  required
                />
              </div>

              <div className="form-group">
                <label htmlFor="new-password">New password</label>
                <input
                  type="password"
                  id="new-password"
                  className="form-control"
                  value={newPassword}
                  onChange={(event) => setNewPassword(event.target.value)}
                  required
                />
              </div>

              <div className="form-group">
                <label htmlFor="confirm-password">Confirm new password</label>
                <input
                  type="password"
                  id="confirm-password"
                  className="form-control"
                  value={confirmPassword}
                  onChange={(event) => setConfirmPassword(event.target.value)}
                  required
                />
              </div>

              <button type="submit" className="btn btn-primary" disabled={loading}>
                {loading ? 'Changing...' : 'Change password'}
              </button>
            </form>
          </section>
        </div>

        <section className="logout-section surface-card">
          <div>
            <h2>Account</h2>
            <p>Signed in as <strong>{user?.email}</strong></p>
          </div>
          <button className="btn btn-danger" onClick={logout}>
            Logout
          </button>
        </section>
      </div>
    </div>
  );
};

export default Settings;
